module.exports = __webpack_public_path__ + "static/media/person.72bd5b90.svg";